import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  // constructor(private faService: AngularFireAnalytics) {}

  createGAEvent(category: string, action: string, label: string) {
    if (!isDevMode()) {
      (<any>window).ga('send', 'event', {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: 1,
      });
    }
  }

  createGAPageView(page) {
    if (!isDevMode()) {
      (<any>window).ga('set', 'page', page);
      (<any>window).ga('send', 'pageview');
    }
  }

  createFAScreenView(app: string, page: string) {
    if (!isDevMode()) {
      const scrubbedPage = page.split('?')[0];
      const eventParams = {
        app_name: app,
        event_category: 'screen_view',
        screen_name: scrubbedPage,
      };
      // this.faService.logEvent('screen_view', eventParams);
    }
  }

  createFASimpleEvent(app: string, eventName: string, value: string | number) {
    if (!isDevMode()) {
      const eventParams = {
        app_name: app,
        eventValue: value,
      };
      // this.faService.logEvent(eventName, eventParams);
    }
  }
}

export enum ANALYTICS_APP_NAMES_ENUM {
  meetup = 'meetup',
}
